<template>
  <section>
    <b-container fluid class="works">
      <b-row class="justify-content-center">
        <b-col
          cols="11"
          sm="10"
          md="9"
          xl="8"
          class="flex-column justify-content-center d-flex"
        >
          <div class="jian">
            <v-com_title :msg="hTitle[0]"></v-com_title>

            <b-container fluid style="padding: 3% 0">
              <b-row class="justify-content-start works_box">
                <b-col
                  cols="4"
                  md="3"
                  xl="2"
                  class="justify-content-center d-flex item-logo"
                  v-for="(item, index) in airportList"
                  :key="index"
                >
                  <span><img :src="item.logo" alt="" /></span>
                </b-col>
              </b-row>
              <b-row class="justify-content-start works_box">
                <b-col
                  cols="4"
                  md="3"
                  xl="2"
                  class="justify-content-center d-flex item-logo"
                  v-for="(item, index) in companyList"
                  :key="index"
                >
                  <span><img :src="item.logo" alt="" /></span>
                </b-col>
              </b-row>
              <b-row class="justify-content-start works_box">
                <b-col
                  cols="4"
                  md="3"
                  xl="2"
                  class="justify-content-center d-flex item-logo"
                  v-for="(item, index) in collegeList"
                  :key="index"
                >
                  <span><img :src="item.logo" alt="" /></span>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col
          cols="11"
          sm="10"
          md="9"
          xl="8"
          class="flex-column justify-content-center d-flex"
        >
          <div class="jian">
            <v-com_title :msg="hTitle[1]"></v-com_title>
            <b-container fluid style="padding: 3% 0">
              <b-row class="justify-content-start works_box">
                <b-col
                  cols="4"
                  md="3"
                  xl="2"
                  class="justify-content-center d-flex item-logo"
                  v-for="(item, index) in linkList"
                  :key="index"
                  @click="goMin(item.linkUrl)"
                  style="cursor: pointer"
                >
                  <span><img :src="item.logo" alt="" /></span>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>
<script>
import Com_title from "../com-title";
import Link from "./link";
export default {
  components: {
    "v-com_title": Com_title,
    "v-link": Link,
  },
  data() {
    return {
      hTitle: ["合作单位", "友情链接"],
      airportList: [],
      companyList: [],
      collegeList: [],
      OneList: [],
      TwoList: [],
      ThreeList: [],
      linkList: [],
    };
  },
  watch: {},
  created() {
    this.getWorkList();
  },
  mounted() {},
  methods: {
    goMin(url) {
      if (url) {
        if (!url) return false;
        else {
          window.open(url);
          // window.location.href = url
        }
      }
    },
    getWorkList() {
      this.airportList = [
        {
          id: "01",
          // logo: require("@/assets/images/index/works/bjsdhkyxgs.png"),
          logo: require("@/assets/images/index/works/gh.png"),
        },
        { id: "02", logo: require("@/assets/images/index/works/yz.png") },
        {
          id: "03",
          logo: require("@/assets/images/index/works/lh.png"),
        },
        {
          id: "04",
          logo: require("@/assets/images/index/works/bjsdhkyxgs.png"),
        },
        {
          id: "05",
          logo: require("@/assets/images/index/works/df.png"),
        },
        {
          id: "06",
          logo: require("@/assets/images/index/works/sd.png"),
        },
        {
          id: "07",
          logo: require("@/assets/images/index/works/xm.png"),
        },
        {
          id: "08",
          logo: require("@/assets/images/index/works/cqhk.png"),
        },
        {
          id: "09",
          logo: require("@/assets/images/index/works/jx.png"),
        },
        {
          id: "10",
          logo: require("@/assets/images/index/works/cl.png"),
        },
        {
          id: "11",
          logo: require("@/assets/images/index/works/zgnf.png"),
        },
        { id: "12", logo: require("@/assets/images/index/works/hnhk.png") },
        {
          id: "13",
          logo: require("@/assets/images/index/works/cdhkyxgs.png"),
        },
        {
          id: "14",
          logo: require("@/assets/images/index/works/hxhkgfyxgs.png"),
        },
        {
          id: "15",
          logo: require("@/assets/images/index/works/px.png"),
        },
        {
          id: "16",
          logo: require("@/assets/images/index/works/sz.png"),
        },
      ];
      this.companyList = [
        {
          id: "01",
          logo: require("@/assets/images/index/works/shoudu.png"),
        },
        {
          id: "02",
          logo: require("@/assets/images/index/works/nmgjcjt.png"),
        },
        {
          id: "03",
          logo: require("@/assets/images/index/works/hljjcjt.png"),
        },

        {
          id: "04",
          logo: require("@/assets/images/index/works/sh.png"),
        },
        {
          id: "05",
          logo: require("@/assets/images/index/works/sdjc.png"),
        },
        {
          id: "06",
          logo: require("@/assets/images/index/works/hljcjt.png"),
        },
        {
          id: "07",
          logo: require("@/assets/images/index/works/hnjcjt.png"),
        },

        {
          id: "08",
          logo: require("@/assets/images/index/works/yn.png"),
        },
        {
          id: "09",
          logo: require("@/assets/images/index/works/xb.png"),
        },
        {
          id: "10",
          logo: require("@/assets/images/index/works/xj.png"),
        },
      ];
      this.collegeList = [
        {
          id: "29",
          logo: require("@/assets/images/index/works/mh.png"),
        },
        {
          id: "30",
          logo: require("@/assets/images/index/works/fx.png"),
        },
        {
          id: "31",
          logo: require("@/assets/images/index/works/hbwlgjhkxx.png"),
        },
      ];
      this.linkList = [
        {
          id: "29",
          logo: require("@/assets/images/index/works/logo-m.png"),
          linkUrl: "http://www.caac.gov.cn/INDEX/",
        },
      ];
    },
  },
};
</script>
<style>
@import "../../../assets/css/work.css";
</style>
<style lang="less" scoped>
.works_box {
  /* padding: 3% 0; */
}
@media (max-width: 575px) {
  .link-text {
    font-size: 14px;
    font-family: "PingFang Bold";
    color: #333;
    line-height: 2.582;
    margin: 0 20px 0 0;
  }
}

/* // Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767px) {
}

/* // Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991px) {
}

/* // Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199px) {
}

/* // Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
}
</style>
